import { render } from "./Messages.vue?vue&type=template&id=746ac492"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/private/Messages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "746ac492"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('746ac492', __exports__)) {
    api.reload('746ac492', __exports__)
  }
  
  module.hot.accept("./Messages.vue?vue&type=template&id=746ac492", () => {
    api.rerender('746ac492', render)
  })

}


export default __exports__